module.exports = __webpack_public_path__ + "static/media/trash.a6bab00b.svg";